import TitleIcon from '@mui/icons-material/Title';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
import HighlightIcon from '@mui/icons-material/Highlight';
import UndoIcon from '@mui/icons-material/Undo';
import RedoIcon from '@mui/icons-material/Redo';
import LinkIcon from '@mui/icons-material/Link';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
import Tooltip from '@mui/material/Tooltip';

const customTooltipIcons: Record<string, JSX.Element> = {
  ['customTitle']: (
    <Tooltip title="Title" placement="top">
      <TitleIcon />
    </Tooltip>
  ),
  ['customBold']: (
    <Tooltip title="Bold" placement="top">
      <FormatBoldIcon />
    </Tooltip>
  ),
  ['customItalic']: (
    <Tooltip title="Italic" placement="top">
      <FormatItalicIcon />
    </Tooltip>
  ),
  ['customUnderline']: (
    <Tooltip title="Underline" placement="top">
      <FormatUnderlinedIcon />
    </Tooltip>
  ),
  ['customHighlight']: (
    <Tooltip title="Highlight" placement="top">
      <HighlightIcon />
    </Tooltip>
  ),
  ['customUndo']: (
    <Tooltip title="Undo" placement="top">
      <UndoIcon />
    </Tooltip>
  ),
  ['customRedo']: (
    <Tooltip title="Redo" placement="top">
      <RedoIcon />
    </Tooltip>
  ),
  ['customLink']: (
    <Tooltip title="Link" placement="top">
      <LinkIcon />
    </Tooltip>
  ),
  ['customNumberList']: (
    <Tooltip title="Numbered list" placement="top">
      <FormatListNumberedIcon />
    </Tooltip>
  ),
  ['customBulletList']: (
    <Tooltip title="Bullet list" placement="top">
      <FormatListBulletedIcon />
    </Tooltip>
  ),
  ['customQuoteList']: (
    <Tooltip title="Quote" placement="top">
      <FormatQuoteIcon />
    </Tooltip>
  ),
  ['alignLeft']: <FormatAlignLeftIcon />,
  ['alignCenter']: <FormatAlignCenterIcon />,
  ['alignRight']: <FormatAlignRightIcon />
};

export default customTooltipIcons;
